import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import { computeTotoTotal } from "../utils/functions";
import t from "../Locale";

import { Button, Dialog, TextField, Typography } from "@material-ui/core";

import BottomFloat2 from "../components/containers/BottomFloat2";

import { useHistory } from "react-router";
import { setPersonalDetails } from "../redux/items/PersonalDetails";
import LastSecondToto from "../components/LastSecondToto";
import CardToto from "../components/CardToto";
import FetchNoLogin from "../components/Fetch/FetchNoLogin";
import classNames from "classnames";
import FetchLogin from "../components/Fetch/FetchLogin";
import {
  appendPlaceBetFinal2,
  setPlaceBetFinal2,
} from "../redux/items/TotoPlaceBetFinal";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Confirm from "../components/Confirm";

const TotoPersonalDetails = () => {
  const dispatch = useDispatch();
  const hist = useHistory();
  const personalDetails = useSelector((state) => state.personalDetails);
  const user = useSelector((state) => state.login.user);
  const token = useSelector((state) => state.login.token);
  const totoSet = useSelector((state) => state.drawSet.TotoSet);
  const totoPlaceBetFinal = useSelector((state) => state.totoPlaceBetFinal);

  const bottomRef = useRef(null);

  const [v, setV] = useState({
    name: "",
    email: "",
    error: "",

    dialogSaveWishList: false,
    nameWishList: "",
    errorSaveWishlist: "",

    dialogLoadWishList: false,
    wishList: [],

    dialogDeleteWishList: false,
    wishListId: 0,

    dialogUseWishList: false,
    wishListKey: 0,
  });

  const setV2 = (v2) => {
    setV((prev) => ({ ...prev, ...v2 }));
  };

  const reqPersonalDetails = FetchNoLogin("personal-details", {
    data: {
      name: v.name,
      email: v.email,
      token: token,
    },
    callbackInit: () => {
      setV2({ error: "" });
    },
    callback: (cb) => {
      if (cb.response.success) {
        dispatch(
          setPersonalDetails({
            name: v.name,
            email: v.email,
          })
        );
        setTimeout(() => {
          hist.push("/checkout-toto");
        }, 0);
      } else {
        setV2({ error: cb.response.message });
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    },
  });

  const reqBetSave = FetchLogin("wishlist/toto/save", {
    data: {
      token: token,
      name: v.nameWishList,
      bet: totoPlaceBetFinal,
    },
    callbackInit: () => {
      setV2({ errorSaveWishlist: "" });
    },
    callback: (cb) => {
      if (cb.response.success)
        setV2({
          dialogSaveWishList: false,
          nameWishList: "",
          errorSaveWishlist: "",
        });
      else setV2({ errorSaveWishlist: cb.response.message });
    },
  });

  // const reqBetLoad = FetchLogin("wishlist/toto/load", {
  //   data: {
  //     token: token,
  //   },
  //   callbackInit: () => {},
  //   callback: (cb) => {
  //     setV2({ dialogLoadWishList: true, wishList: cb.response.data.bets });
  //   },
  // });

  const reqBetDelete = FetchLogin("wishlist/toto/delete", {
    data: {
      token: token,
      id: v.wishListId,
    },
    callbackInit: () => {},
    callback: (cb) => {
      setV2({ dialogDeleteWishList: false, wishList: cb.response.data.bets });
    },
  });

  useEffect(() => {
    setV2({ name: personalDetails.name, email: personalDetails.email });
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    // eslint-disable-next-line
  }, []);

  return (
    <MainContainer
      render={<TopBar leftSide="-1" title={t("Personal Details")} />}
    >
      {/* <div style={{ textAlign: "center" }}>
        <Button
          onClick={() => reqBetLoad.handleTrigger()}
          style={{ padding: "8px 12px", fontSize: 16 }}
        >
          Wishlist
        </Button>
      </div> */}

      <div style={{ marginTop: 10 }}>
        <LastSecondToto />
      </div>

      <CardToto canDelete={true} />
      <Typography
        variant="h3"
        style={{
          textAlign: "center",
          fontSize: 24,
          color: "#6D6D6D",
          marginTop: 20,
          fontWeight: "bold",
        }}
      >
        {t("Personal Details")}
      </Typography>
      {/* {JSON.stringify(user, null, 2)} */}
      {user?.name === "" || user?.name === undefined || user?.name === null ? (
        <>
          <TextField
            fullWidth
            placeholder={t("Full Name")}
            className={classNames("pd-input", "personal-input")}
            value={v.name}
            onChange={(e) => setV2({ name: e.target.value })}
          />

          <TextField
            type="email"
            fullWidth
            placeholder={t("Email")}
            className={classNames("pd-input", "personal-input")}
            value={v.email}
            onChange={(e) => setV2({ email: e.target.value })}
            style={{ marginBottom: 16 }}
          />
        </>
      ) : (
        <div
          style={{
            fontSize: 18,
            width: "80%",
            margin: "0 auto",
            marginTop: 20,
          }}
        >
          <label>Name: </label>
          <b>{user?.name}</b>
          <br />

          {user?.email !== "" && user?.name !== undefined ? (
            <>
              <label>Email: </label>
              <b>{user?.email}</b>
              <br />
            </>
          ) : null}
        </div>
      )}
      <Typography
        dangerouslySetInnerHTML={{
          __html: v.error,
        }}
        style={{
          color: "red",
          textAlign: "center",
          paddingTop: 20,
          paddingBottom: 20,
        }}
      />
      <div ref={bottomRef} />

      <Dialog open={v.dialogLoadWishList} maxWidth="sm">
        <div style={{ padding: "24px 36px", textAlign: "center" }}>
          <h3
            style={{ fontFamily: "arial", textAlign: "center", fontSize: 28 }}
          >
            Wishlist Load Menu
          </h3>
          <div style={{ marginBottom: 20 }}>
            {v.wishList.length > 0 ? (
              <ul className="wishlist-list">
                {v.wishList.map((a, aI) => {
                  return (
                    <li key={aI}>
                      <DeleteIcon
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          v.dialogDeleteWishList = setV2({
                            dialogDeleteWishList: true,
                            wishListId: a.id,
                          });
                        }}
                      />
                      <span>{a.name}</span>
                      <ArrowForwardIosIcon
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setV2({ dialogUseWishList: true, wishListKey: aI })
                        }
                      />
                    </li>
                  );
                })}
              </ul>
            ) : (
              <span>No Saved Wishlist</span>
            )}
          </div>
          <Button
            style={{ fontSize: 12, padding: "8px 12px", background: "red" }}
            onClick={() => {
              setV2({ dialogLoadWishList: false });
            }}
          >
            Close
          </Button>
        </div>
      </Dialog>

      <Dialog open={v.dialogSaveWishList} maxWidth="sm">
        <div style={{ padding: "24px 36px", textAlign: "center" }}>
          <h3
            style={{ fontFamily: "arial", textAlign: "center", fontSize: 28 }}
          >
            Wishlist Save Menu
          </h3>
          <div style={{ marginBottom: 20 }}>
            <TextField
              placeholder="Wishlist Name"
              onChange={(event) => setV2({ nameWishList: event.target.value })}
              value={v.nameWishList}
            />
          </div>
          <Button
            style={{ fontSize: 24 }}
            onClick={() => reqBetSave.handleTrigger()}
          >
            Save
          </Button>{" "}
          <br />
          <span style={{ color: "red", display: "block", marginTop: 10 }}>
            {v.errorSaveWishlist}
          </span>
          <br />
          <Button
            style={{ fontSize: 12, padding: "8px 12px", background: "red" }}
            onClick={() => setV2({ dialogSaveWishList: false })}
          >
            Close
          </Button>
        </div>
      </Dialog>

      <Confirm
        open={v.dialogDeleteWishList}
        onClose={() => setV2({ dialogDeleteWishList: false })}
        question="Are you Sure? You want to Delete this"
        choices={[
          {
            title: "Confirm",
            onClick: () => {
              reqBetDelete.handleTrigger();
            },
          },
        ]}
      />

      <Confirm
        open={v.dialogUseWishList}
        onClose={() => setV2({ dialogUseWishList: false })}
        question="Add on Existing or Remove Others?"
        choice="3"
        choices={[
          {
            title: "Add on Existing",
            onClick: () => {
              let bets = v.wishList[v.wishListKey].bets;
              setV2({ dialogUseWishList: false, dialogLoadWishList: false });
              dispatch(appendPlaceBetFinal2(bets));
            },
          },
          {
            title: "Only This",
            onClick: () => {
              let bets = v.wishList[v.wishListKey].bets;
              setV2({ dialogUseWishList: false, dialogLoadWishList: false });
              dispatch(setPlaceBetFinal2(bets));
            },
          },
        ]}
      />

      <BottomFloat2
        total={computeTotoTotal(totoPlaceBetFinal, totoSet)}
        title={"Next"}
        wishListActive={true}
        wishListClick={() => setV2({ dialogSaveWishList: true })}
        onClick={() => {
          if (
            user?.name === "" ||
            user?.name === undefined ||
            user?.name === null
          )
            reqPersonalDetails.handleTrigger();
          else hist.push("/checkout-toto");
        }}
      />
    </MainContainer>
  );
};

export default TotoPersonalDetails;
